/**
 * Data freshness config — single source of truth for "rates updated" badges
 * across the Calculator Suite. Update only the date strings here when the
 * underlying tables change.  Format: "YYYY-MM".
 */
export const DATA_FRESHNESS = {
  emi:           "2026-06",
  rentbuy:       "2026-06",
  capgains:      "2026-06",
  stampduty:     "2026-06",
  rental:        "2026-06",
  affordability: "2026-06",
  netWorth:      "2026-06",
  cii:           "2026-06",  // CBDT FY 2025-26
  lenders:       "2026-06",
};

export function freshnessTone(yyyymm) {
  if (!yyyymm) return "muted";
  const [y, m] = yyyymm.split("-").map(Number);
  const then = new Date(y, m - 1, 1);
  const now = new Date();
  const monthsAgo = (now.getFullYear() - then.getFullYear()) * 12 + (now.getMonth() - then.getMonth());
  if (monthsAgo <= 3) return "green";
  if (monthsAgo <= 6) return "amber";
  return "red";
}

export function freshnessLabel(yyyymm) {
  if (!yyyymm) return "";
  const [y, m] = yyyymm.split("-").map(Number);
  const d = new Date(y, m - 1, 1);
  return d.toLocaleDateString("en-IN", { month: "short", year: "numeric" });
}

// City defaults for Rent vs Buy and Affordability
export const CITY_DEFAULTS = {
  Mumbai:       { appreciation: 6,    rent_increase: 5,   price_rent_ratio: 40 },
  Bangalore:    { appreciation: 8,    rent_increase: 6,   price_rent_ratio: 30 },
  "Delhi-NCR":  { appreciation: 6.5,  rent_increase: 5,   price_rent_ratio: 35 },
  Hyderabad:    { appreciation: 9,    rent_increase: 7,   price_rent_ratio: 25 },
  Pune:         { appreciation: 7,    rent_increase: 6,   price_rent_ratio: 28 },
  Chennai:      { appreciation: 6,    rent_increase: 5,   price_rent_ratio: 30 },
  Other:        { appreciation: 7,    rent_increase: 5.5, price_rent_ratio: 30 },
};
